import { Button } from "antd";
import React, { useMemo } from "react";
import { useQueryGeneratorContext } from "../../context/QueryBuilder/QueryGeneratorContext";
import { useQueryTablesDataContext } from "../../context/QueryBuilder/QueryTablesDataContext";

const SelectAllButton = () => {
  const { handleOnSelectAllTables, handleOnResetAll, selectedTableNames } =
    useQueryGeneratorContext();
  const { overallQueryItemMapByTableName, isTableListLoading } =
    useQueryTablesDataContext();

  const isAllTablesSelected = useMemo(() => {
    const overAllTablesLength = Object.keys(overallQueryItemMapByTableName).length
    if (overAllTablesLength < 1) return false;
    return (
      selectedTableNames.length === overAllTablesLength
    );
  }, [overallQueryItemMapByTableName, selectedTableNames.length]);

  return (
    <div className="d-flex align-items-center gap-1">
      <Button
        variant="outlined"
        className="reset-btn"
        onClick={
          isAllTablesSelected ? handleOnResetAll : handleOnSelectAllTables
        }
      >
        {isAllTablesSelected && !isTableListLoading
          ? "Deselect all tables"
          : "Select all tables"}
      </Button>
    </div>
  );
};

export default SelectAllButton;
